import React, { FC, memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { APP_URL } from '../../config/config';

interface helmet {
  title: string;
  link?: string;
  description?: string;
  pageUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  keywords?: string;
  ogImageAlt?: string;
  jsonLd?: any;
}

const CustomHelmet: FC<helmet> = ({
  title,
  description,
  pageUrl,
  ogTitle,
  ogDescription,
  ogImage,
  keywords,
  ogImageAlt,
  jsonLd,
}) => {
  const url = pageUrl ? pageUrl : '';
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="robots" content="index, follow" />
      <title>{title} | loop</title>
      <link rel="canonical" href={APP_URL ? APP_URL + url : ''} />
      <meta name="description" content={description ? description : ''} />
      <meta property="og:url" content={APP_URL ? APP_URL + url : ''} />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={ogTitle ? ogTitle : title ? title : ''}
      />
      <meta
        property="og:description"
        content={ogDescription ? ogDescription : description ? description : ''}
      />
      <meta
        property="og:image"
        itemProp="image"
        content={ogImage ? ogImage : ''}
      />
      <meta
        property="og:image:url"
        itemProp="image"
        content={ogImage ? ogImage : ''}
      />
      <meta property="og:keywords" content={keywords ? keywords : ''} />
      <meta property="og:image:alt" content={ogImageAlt ? ogImageAlt : ''} />
      <meta property="og:site_name" content="Loop" />
      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta name="twitter:site" content={APP_URL ? APP_URL + url : ''} />
      <meta
        name="twitter:title"
        content={ogTitle ? ogTitle : title ? title : ''}
      />
      <meta
        name="twitter:description"
        content={ogDescription ? ogDescription : description ? description : ''}
      />
      <meta name="twitter:image" content={ogImage ? ogImage : ''} />
      <meta name="twitter:image:alt" content={ogImageAlt ? ogImageAlt : ''} />
      {jsonLd ? <script type="application/ld+json">{jsonLd}</script> : null}
    </Helmet>
  );
};

export default memo(CustomHelmet);
